module.exports = __webpack_public_path__ + "static/lagoa-nova-logo-96e238442a71c8bf82a1cd2b0874b760.jpg";